/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PriceDetails } from './';
import {
    PriceDetailsFromJSON,
    PriceDetailsFromJSONTyped,
    PriceDetailsToJSON,
} from './';

/**
 * 
 * @export
 * @interface Price
 */
export interface Price {
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    ht: number;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    currencyCode: string;
    /**
     * 
     * @type {PriceDetails}
     * @memberof Price
     */
    details?: PriceDetails;
}

/**
 * Check if a given object implements the Price interface.
 */
export function instanceOfPrice(value: object): value is Price {
    if (!('ht' in value) || value['ht'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function PriceFromJSON(json: any): Price {
    return PriceFromJSONTyped(json, false);
}

export function PriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Price {
    if (json == null) {
        return json;
    }
    return {
        
        'ht': json['ht'],
        'currencyCode': json['currencyCode'],
        'details': json['details'] == null ? undefined : PriceDetailsFromJSON(json['details']),
    };
}

export function PriceToJSON(value?: Price | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ht': value['ht'],
        'currencyCode': value['currencyCode'],
        'details': PriceDetailsToJSON(value['details']),
    };
}

